/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_timer_u30m_use3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Timing a steady-state cardio session like a jog or bike ride.`)
};

const es_timer_u30m_use3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cronometrar una sesión de cardio a ritmo constante, como trotar o andar en bicicleta.`)
};

const de_timer_u30m_use3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eine Cardio-Session mit gleichbleibender Intensität stoppen, etwa Joggen oder Radfahren.`)
};

const nl_timer_u30m_use3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Een duurtraining timen, zoals joggen of fietsen.`)
};

const fr_timer_u30m_use3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chronométrer une session de cardio en endurance comme un footing ou une sortie à vélo.`)
};

const it_timer_u30m_use3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cronometrare una sessione di cardio a intensità costante come una corsa leggera o un giro in bici.`)
};

const pt_br2_timer_u30m_use3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cronometrar uma sessão de cardio em ritmo constante, como uma corrida leve ou um passeio de bicicleta.`)
};

const pt_timer_u30m_use3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cronometrar uma sessão de cardio de intensidade constante, como uma corrida ou um passeio de bicicleta.`)
};

const ja_timer_u30m_use3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ジョギングや自転車など持久系有酸素運動のセッションを計測する。`)
};

const zh_timer_u30m_use3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`为慢跑或骑行等稳态有氧运动计时。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const timer_u30m_use3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.timer_u30m_use3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("timer_u30m_use3", locale)
	if (locale === "en") return en_timer_u30m_use3(inputs)
	if (locale === "es") return es_timer_u30m_use3(inputs)
	if (locale === "de") return de_timer_u30m_use3(inputs)
	if (locale === "nl") return nl_timer_u30m_use3(inputs)
	if (locale === "fr") return fr_timer_u30m_use3(inputs)
	if (locale === "it") return it_timer_u30m_use3(inputs)
	if (locale === "pt-BR") return pt_br2_timer_u30m_use3(inputs)
	if (locale === "pt") return pt_timer_u30m_use3(inputs)
	if (locale === "ja") return ja_timer_u30m_use3(inputs)
	return zh_timer_u30m_use3(inputs)
};